<template>
  <div class="cont-box">
    <el-table :data="datas" style="width: 100%;" max-height="580" border>
      <el-table-column prop="period" label="月度信息"></el-table-column>
      <el-table-column prop="employeeName" label="姓名"></el-table-column>
      <el-table-column prop="dept" label="部门"></el-table-column>
      <el-table-column prop="monthScore" label="本月积分"></el-table-column>
      <el-table-column prop="totalScore" label="当前累计积分"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'IntegralConfirm',
    props: ['datas'],
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
</style>
